<script setup lang="ts">
import {RouterLink, useRouter} from 'vue-router'
import { useI18n } from 'vue-i18n'
import { KsButton } from '@aschehoug/kloss'

const { uri } = defineProps<{ uri: string }>()

const router = useRouter()
const { t } = useI18n()
</script>

<template>
  <KsButton
    :is="RouterLink"
    :to="{ path: uri }"
    variant="border"
    size="medium"
    shape="rounded"
  >
    {{ t('filters.toLegacySubject') }}
  </KsButton>
</template>
